import styled from 'styled-components';
import Modal from 'components/common/Modal';
import PlaceSelector from 'components/place/PlaceSelector';
import palette from 'lib/styles/palette';
import usePlanUploader from 'hooks/place/usePlanUploader';
import Loading from 'components/common/Loading';
import { useState } from 'react';

const PlanUploader = ({
  onClose,
  edit,
  setShowErrorModal,
  setNotiMsg,
  replace,
  spaceId,
  getStoreQuery,
}) => {
  const [isApply, setApply] = useState(false);
  const { name, errors, uploadPlanMutation, onSubmit, onChange, onChangeImg } =
    usePlanUploader(
      onClose,
      edit,
      setShowErrorModal,
      setNotiMsg,
      replace,
      spaceId,
      setApply,
    );

  return (
    <Modal closeModal={onClose}>
      <PlanUploaderBlock>
        {uploadPlanMutation.isLoading ? (
          <Loading padding />
        ) : (
          <>
            <div className="modal-title">
              {replace ? '도면 수정' : '도면 등록'}
            </div>
            {!replace && (
              <>
                <div className="row">
                  <div>층</div>
                  <PlaceSelector />
                </div>
                <div className="row">
                  <div>공간</div>
                  <StyledInput
                    type="text"
                    placeholder="필수"
                    name="name"
                    value={name}
                    onChange={onChange}
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    fontSize: 10,
                    color: 'red',
                  }}
                >
                  {errors.name && errors.name}
                </div>
              </>
            )}
            <div className="row">
              <div>도면 업로드</div>
              <StyledInputFile
                type="file"
                accept="image/*"
                onChange={onChangeImg}
              />
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                fontSize: 10,
                color: 'red',
              }}
            >
              {errors.selectedFile && errors.selectedFile}
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '1.5rem',
                marginBottom: '1rem',
              }}
            >
              <StyledButton cancel onClick={onClose}>
                취소
              </StyledButton>
              <StyledButton onClick={onSubmit}>
                {replace ? '적용' : '확인'}
              </StyledButton>
              {replace && (
                <StyledButton
                  onClick={() => {
                    getStoreQuery.refetch();
                    onClose();
                  }}
                  disabled={!isApply}
                >
                  확인
                </StyledButton>
              )}
            </div>
          </>
        )}
      </PlanUploaderBlock>
    </Modal>
  );
};

export default PlanUploader;

const PlanUploaderBlock = styled.div`
  width: 360px;
  padding: 0 20px;
  .modal-title {
    margin-top: 1rem;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
  }

  .row {
    margin-top: 1rem;
    display: flex;
    justify-content: space-between;
    margin-left: 10px;
  }
`;

const StyledInput = styled.input`
  border: solid 1px #dfdfdf;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.05);
  font-size: 13px;
  width: 200px;
  padding: 3px 6px;
  &::placeholder {
    color: #c6c6c6;
  }
`;

const StyledInputFile = styled.input`
  font-size: 12px;
  height: 100%;
  width: 200px;
`;

const StyledButton = styled.button`
  padding: 4px 10px;
  border: none;
  border-radius: 5px;
  background: ${props => (props.cancel ? palette.theme[0] : palette.theme[3])};
  color: #fff;
  font-size: 8px;
  cursor: pointer;
  &:hover {
    background: ${palette.theme[2]};
  }
  & + & {
    margin-left: 1rem;
  }
  &:disabled {
    background-color: ${palette.theme[0]};
  }
`;
